import { Selector } from "@ngxs/store";
import { VariablesSubtreesState, VariablesSubtreesStateModel } from "./variables-subtrees.state";

export class VariablesSubtreesGetterState {
  @Selector([VariablesSubtreesState])
  static getVariableSubtree(state: VariablesSubtreesStateModel) {
    return state.subtree;
  }
}